// src/pages/Settings.jsx

import React from 'react';
import { NavLink, Routes, Route, Navigate } from 'react-router-dom';
import { Users, Building2, Database, ShieldCheck } from 'lucide-react';
import SettingsTeam from './SettingsTeam';
import SettingsOrganization from './SettingsOrganization';
import SettingsBIAccess from './SettingsBIAccess';
import SettingsSecurity from './SettingsSecurity';

const NAV = [
  { to: 'team',         icon: Users,     label: 'Team' },
  { to: 'organization', icon: Building2, label: 'Organization' },
  { to: 'bi-access',    icon: Database,  label: 'BI Access' },
  { to: 'security',     icon: ShieldCheck, label: 'Security' },
];

export default function Settings() {
  return (
    <div className="flex gap-8">
      {/* Left-rail sub-navigation */}
      <aside className="w-56 flex-shrink-0">
        <h1 className="text-3xl font-semibold tracking-tight text-white mb-2">
          Settings
        </h1>
        <p className="text-sm text-[#a0a0a0] mb-6">
          Manage your team, organization, BI access, and security
        </p>
        <nav className="flex flex-col gap-1">
          {NAV.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                  isActive
                    ? 'bg-[#1a1a1a] text-white'
                    : 'text-[#a0a0a0] hover:text-white hover:bg-[#1a1a1a]/50'
                }`
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Main pane */}
      <div className="flex-1 min-w-0">
        <Routes>
          <Route index element={<Navigate to="team" replace />} />
          <Route path="team" element={<SettingsTeam />} />
          <Route path="organization" element={<SettingsOrganization />} />
          <Route path="bi-access" element={<SettingsBIAccess />} />
          <Route path="security" element={<SettingsSecurity />} />
        </Routes>
      </div>
    </div>
  );
}